import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";

function getBlock(page, type) {
  return (
    (page?.sections || [])
      .flatMap((section) => section.blocks || [])
      .find((block) => block.type === type)?.data || {}
  );
}

function Icon({ name, ...rest }) {
  const key = (name || "")
    .split("-")
    .map((w) => w[0]?.toUpperCase() + w.slice(1))
    .join("");

  const C = Icons[key] || Icons.Sparkles;

  return <C {...rest} />;
}

export default function SoftwareModulesPage({ page }) {
  const hero = getBlock(page, "modules_hero");
  const supportedModules = getBlock(page, "supported_modules");
  const modules = supportedModules.modules || [];

  return (
    <div data-testid="modules-page">
      <section className="sqit-section">
        <div className="sqit-container">
          <div className="max-w-3xl">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#006B3C]">
              {hero.badge}
            </div>

            <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold text-gray-900 tracking-tight">
              {hero.title}
            </h1>

            <p className="mt-5 text-lg text-gray-600 leading-relaxed">
              {hero.description}
            </p>
          </div>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {modules.map((m, index) => (
              <div
                key={index}
                className="sqit-card sqit-card-hover p-6 flex flex-col"
              >
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-xl bg-[#006B3C] text-white flex items-center justify-center">
                    <Icon name={m.icon} size={20} strokeWidth={1.75} />
                  </div>

                  <div>
                    <div className="text-xs text-gray-500 uppercase tracking-wider">
                      Pipeline
                    </div>

                    <div className="font-display font-semibold text-gray-900 text-lg">
                      {m.title}
                    </div>
                  </div>
                </div>

                <p className="mt-4 text-base font-medium text-gray-700 leading-7">
                  {m.tagline}
                </p>

                <p className="mt-3 text-sm text-gray-600 leading-6">
                  {m.description}
                </p>

                {m.show_sample_report && (
                  <div className="mt-auto pt-6 flex flex-wrap gap-2">
                    <Link
                      to={`/sample-reports/${m.sample_report}`}
                      target="_blank"
                      className="inline-flex items-center gap-2 rounded-md border border-[#006B3C] bg-white px-5 py-2.5 text-sm font-semibold text-[#006B3C] transition-all duration-200 hover:bg-[#006B3C] hover:text-white"
                    >
                      View Report
                      <ArrowRight size={16} />
                    </Link>
                    <a
                      href={`/sample-reports/${m.sample_report}.html`}
                      download={`${m.sample_report}.html`}
                      className="inline-flex items-center gap-2 rounded-md bg-[#006B3C] px-5 py-2.5 text-sm font-semibold text-white transition-all duration-200 hover:bg-[#005A33]"
                    >
                      Download
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}